import { prop } from 'ramda';
import { useMemo, useCallback } from 'react';
import { useFormatter } from 'js/hooks/useFormatter';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { useDynamicReducerSelector } from '../store';

import style from '../TermsAndConditionsHistory.scss';

export const useTableData = () => {
    const formatter = useFormatter();
    const translate = useComponentTranslations();
    const termsAndConditionsHistory = useDynamicReducerSelector(prop('history'));

    const getCells = useCallback((cellData) => {
        const { tcVersion, acceptDateTime } = cellData;
        const acceptDateTimeFormatted = formatter.getDateTimeShort(formatter.parseImsDate(acceptDateTime));

        return [
            { id: '0', content: acceptDateTimeFormatted, className: style.time },
            { id: '1', content: `${translate('playtech.mobile.system.termsAndConditionsHistory.version')} ${tcVersion}`, className: style.version as string }
        ];
    }, [formatter, translate]);

    return useMemo(() => ({
        tableView: {
            rows: termsAndConditionsHistory.map((item) => ({
                id: item.id,
                rowCells: getCells(item)
            }))
        }
    }), [getCells, termsAndConditionsHistory]);
};
